// This redux state is for the application state such as error/issues.
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface schema {
  zwtToken: string;
  username: String;
  permissions?: any;
  hotels?: any;
  monthlyRateReminder: boolean;
}

const initialState = {
  zwtToken: "",
  username: "",
  permissions: {},
  monthlyRateReminder: false,
} as schema;

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setZwtToken: (state, action: PayloadAction<string>) => {
      state.zwtToken = action.payload;
    },
    setUsername: (state, action: PayloadAction<string>) => {
      state.username = action.payload;
    },
    setPermissions: (state, action: PayloadAction<any>) => {
      state.permissions = action.payload;
    },
    setHotels: (state, action: PayloadAction<any>) => {
      state.hotels = action.payload;
    },
    setMonthlyRateReminder: (state, action: PayloadAction<boolean>) => {
      state.monthlyRateReminder = action.payload;
    },
    resetUser: () => initialState,
  },
});

export const {
  resetUser,
  setZwtToken,
  setUsername,
  setPermissions,
  setHotels,
  setMonthlyRateReminder,
} = userSlice.actions;

export const selectUser = (state: { user: schema }) => state.user;

export default userSlice.reducer;
